import theme from 'config/theme';
import Typography from 'interface/base/Typography';
import {StyleSheet, View} from 'react-native';

export interface SectionProps {
  label: string;
}

export function Section(props: React.PropsWithChildren<SectionProps>) {
  return (
    <View style={styles.root}>
      <View style={styles.header}>
        <Typography
          variant="medium"
          size="sm"
          color={theme.colors.neutral.$500}>
          {props.label}
        </Typography>
      </View>
      {props.children}
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingVertical: 4,
    paddingHorizontal: 16,
  },
  header: {
    paddingBottom: 16,
  },
});
